<template>
  <div>
    <el-dialog title="简历预览" :visible.sync="value" width="870px" :before-close="handleClose">
      <el-scrollbar style="height: 500px;">
        <div class="Job_seeker_infomation">
          <div class="header_info">
            <div class="left_header_avator">
              <img v-if="resume_info.avatar" :src="resume_info.avatar" alt="">
              <img v-else src="@/assets/img/company/detial/jianli/img1.png" alt="">
            </div>
            <div class="right_info">
              <div class="first_header">
                <div class="job_seeker_name">{{ resume_info.name?resume_info.name:'暂无名字'}}</div>
                <div class="sex_icon" :style="{background:resume_info.gender==1?'#4ba1f1':'#ff766f'}">
                  <i class="el-icon-male" v-if="resume_info.gender==1"></i>
                  <i class="el-icon-female" v-else></i>
                </div>
                <div class="status_label">{{ resume_info.active_time?resume_info.active_time:'暂无活跃时间' }}</div>
                <div class="info_box">{{ resume_info.age?resume_info.age:'暂无年龄' }}</div>
                <div class="info_box">{{ resume_info.experience?resume_info.experience:'暂无工作经验' }}</div>
                <div class="info_box">{{ resume_info.degree?resume_info.degree:'暂无学历' }}</div>
                <div class="info">{{resume_info.job_status===null?'暂无状态':StatusOption[resume_info.job_status-1]  }}</div>
              </div>
              <div class="info_detial_box text-overflow-2">
                <div class="info_detial text-overflow-2" v-if="resume_info.personal_strengths" v-html="resume_info.personal_strengths.replace(/\n/g, '<br>')"></div>
                <div class="info_detial" v-else>暂无个人优势</div>
              </div>
            </div>
          </div>
          <div class="detial_box" v-for="(item,index) in detial_info" :key="index">
            <div class="label">{{ item.label }}</div>
            <template v-if="resume_info[item.value].length!=0">
              <div class="content" v-if="item.value=='position'">
                <div class="content_header">
                  <div class="left_content">
                    <div class="line_info" v-for="itemC in resume_info[item.value]">
                      <div class="info_box" v-for="key in item.keys" :key="key">{{ itemC[key] }}</div>
                    </div>
                  </div>
                  <div class="right_content"></div>
                </div>
              </div>
              <div class="content" v-if="item.value=='position_experience'">
                <div class="content_header">
                  <div class="left_content flex">
                    <div class="line_info position_box" v-for="itemC in resume_info[item.value]">
                      {{ itemC.position_name }} {{ itemC.time }}
                    </div>
                  </div>
                  <div class="right_content"></div>
                </div>
              </div>
              <template v-if="item.value=='work_experience'">
                <div class="content">
                  <div class="content_item" v-for="itemC in resume_info[item.value]">
                    <div class="content_header">
                      <div class="left_content">
                        <div class="line_info">
                          <div class="info_box" v-for="key in item.keys" :key="key">{{ itemC[key] }}</div>·{{ itemC.department }}
                        </div>
                      </div>
                      <div class="right_content">{{ itemC.time }}</div>
                    </div>
                    <div class="work_info">
                      业绩：<br>
                      {{ itemC.work_performance }}
                    </div>
                    <div class="work_info">
                      内容：<br>
                      {{ itemC.work_responsibilities }}
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="item.value=='project_experience'">
                <div class="content">
                  <div class="content_item" v-for="itemC in resume_info[item.value]">
                    <div class="content_header">
                      <div class="left_content">
                        <div class="line_info">
                          <div class="info_box" v-for="key in item.keys" :key="key">{{ itemC[key] }}</div>
                        </div>
                      </div>
                      <div class="right_content">{{ itemC.time }}</div>
                    </div>
                    <div class="work_info">
                      业绩：<br>
                      {{ itemC.project_performance }}
                    </div>
                    <div class="work_info">
                      内容：<br>
                      {{ itemC.project_introduction }}
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="item.value=='education'">
                <div class="content">
                  <div class="content_item" v-for="itemC in resume_info[item.value]">
                    <div class="content_header">
                      <div class="left_content">
                        <div class="line_info">
                          <div class="info_box" v-for="key in item.keys" :key="key">{{ itemC[key] }}</div>
                        </div>
                      </div>
                      <div class="right_content">{{ itemC.time }}</div>
                    </div>
                  </div>
                </div>
              </template>
              <div class="content" v-if="item.value=='certificate'">
                <div class="content_header">
                  <div class="left_content flex">
                    <div class="line_info position_box" v-for="itemC in resume_info[item.value]">
                      {{ itemC }}
                    </div>
                  </div>
                  <div class="right_content"></div>
                </div>
              </div>

            </template>
            <div v-else style="color: #666;">暂无{{ item.label }}</div>
          </div>

        </div>
      </el-scrollbar>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  props: ["value", "position_info"],
  data() {
    return {
      job_info: {},
      basic_info: [
        {
          label: "公司",
          key: "company_mame",
          value: "",
        },
        {
          label: "招聘类型",
          key: "recruitment_type",
          value: "",
        },
        {
          label: "职位名称",
          key: "name",
          value: "",
        },
        {
          label: "职位描述",
          key: "position_introduction",
          value: "",
        },
        {
          label: "职位类型",
          key: "position_type",
          value: "",
        },
        {
          label: "工作地址",
          key: "address",
          value: "",
        },
      ],
      postion_Requirements: [
        {
          label: "经验与学历",
          value: "",
        },
        {
          label: "薪资范围",
          value: "",
        },
      ],
      typeOption: [
        {
          label: "社招全职",
          value: 1,
        },
        {
          label: "应届校园招聘",
          value: 2,
        },
        {
          label: "实习生招聘",
          value: 3,
        },
        {
          label: "兼职招聘",
          value: 4,
        },
      ],
      StatusOption: [
        "离职-随身到岗",
        "在职-暂不考虑",
        "在职-考虑机会",
        "在职-月内到岗",
      ],
      resume_info: {
        id: null, //简历ID
        name: "", //姓名
        avatar: "", //头像
        phone: "", //电话
        gender: null, //性别: 1=男,2=女
        job_status: null, //求职状态: 1=,2=在职-暂不考虑,3=在职-考虑机会,4=在职-月内到岗
        wechat: "", //微信
        email: "", //邮箱
        degree: "", //学历
        personal_strengths: "", //个人优势
        certificate: [], //资格证书
        experience: "", //工作经验年限
        age: "", //年龄
        position: [], //期望职位
        work_experience: [], //工作经历
        project_experience: [], //项目经历
        education: [], //教育经历
        active_time: "", //活跃时间
        position_experience: [], //岗位经验
      },
      detial_info: [
        {
          label: "期望职位",
          arr: [],
          value: "position",
          key: "",
          keys: ["city", "name", "industry", "salary"],
        },
        {
          label: "岗位经验",
          arr: [],
          value: "position_experience",
          key: "",
          keys: [],
        },
        {
          label: "工作经历",
          arr: [],
          value: "work_experience",
          key: "",
          keys: ["company_name", "position_name"],
        },
        {
          label: "项目经验",
          arr: [],
          value: "project_experience",
          key: "",
          keys: ["name", "role"],
        },
        {
          label: "教育经历",
          arr: [],
          value: "education",
          key: "",
          keys: ["school_name", "major", "degree"],
        },
        {
          label: "资格证书",
          arr: [],
          value: "certificate",
          key: "",
        },
      ],
    };
  },
  watch: {
    value: {
      handler(newVal) {
        console.log(newVal, this.position_info.id);

        if (this.value) this.getDetial();
      },
    },
  },
  mounted() {
    if (this.position_info.id) this.getDetial();
  },
  methods: {
    handleClose() {
      this.$emit("closeDrawer");
    },
    getDetial() {
      this.$httpStudent.axiosGetBy(
        this.$api.positionManageResumeDetail,
        { id: Number(this.position_info.id) },
        (res) => {
          if (res.code == 200) {
            Object.assign(this.resume_info, res.data);
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        }
      );
    },
    getDesc(desc) {
      return desc.replace(/\n/g, "<br>");
    },
  },
};
</script>
<style lang='scss' scoped>
:deep(.el-scrollbar__wrap) {
  overflow-x: hidden;
}
.Job_seeker_infomation {
  padding: 10px 20px;
  .header_info {
    display: flex;
    align-items: center;
    .left_header_avator {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        object-fit: cover;
      }
    }
    .right_info {
      margin-left: 15px;
      flex: 1;
      .first_header {
        display: flex;
        align-items: center;
        margin-bottom: 6px;
        .job_seeker_name {
          margin-right: 5px;
        }
        .sex_icon {
          width: 16px;
          height: 16px;
          border-radius: 50%;
          color: #fff;
          font-size: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 5px;
        }
        .status_label {
          color: #fe835c;
        }
        .info_box {
          margin-left: 15px;
          padding-right: 15px;
          position: relative;

          &::before {
            content: "";
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 2px;
            height: 10px;
            background-color: #e5e5e5;
            border-radius: 4px;
          }
        }

        .info {
          margin-left: 10px;
        }
      }
      .info_detial_box {
      }
    }
  }
  .detial_box {
    margin-top: 20px;
    display: flex;
    color: #343434;
    .label {
      width: 60px;
      flex-shrink: 0;
      margin-right: 15px;
    }
    .content {
      flex: 1;

      .content_item {
        margin-bottom: 20px;
      }
      .content_header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .flex {
          display: flex;
          align-items: center;
          gap: 15px;
          flex-wrap: wrap;
        }
        .left_content {
          .position_box {
            background: #f7f7f7;
            padding: 2px 5px;
            box-sizing: border-box;
            border-radius: 4px;
          }
          .line_info {
            display: flex;
            align-items: center;
            .info_box {
              margin-left: 15px;
              padding-right: 15px;
              position: relative;
              &::before {
                content: "";
                position: absolute;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
                width: 2px;
                height: 10px;
                background-color: #e5e5e5;
                border-radius: 4px;
              }
              &:first-child {
                margin-left: 0;
              }

              &:last-child {
                padding-right: 0;
                &::before {
                  display: none;
                }
              }
            }
          }
        }
      }
      .work_info {
        margin-top: 15px;
        color: #888d9b;
      }
    }
  }
}
</style>
